import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const ShoppingCartSvg = () => (
  <svg width='41' height='40' viewBox='0 0 41 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_4049_195146)'>
      <path
        d='M15.0807 36.6667C16.0012 36.6667 16.7474 35.9205 16.7474 35C16.7474 34.0795 16.0012 33.3333 15.0807 33.3333C14.1603 33.3333 13.4141 34.0795 13.4141 35C13.4141 35.9205 14.1603 36.6667 15.0807 36.6667Z'
        stroke='#627B66'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M33.4137 36.6667C34.3342 36.6667 35.0804 35.9205 35.0804 35C35.0804 34.0795 34.3342 33.3333 33.4137 33.3333C32.4933 33.3333 31.7471 34.0795 31.7471 35C31.7471 35.9205 32.4933 36.6667 33.4137 36.6667Z'
        stroke='#627B66'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.74707 1.66667H8.41374L12.8804 23.9833C13.0328 24.7507 13.4503 25.4399 14.0596 25.9305C14.669 26.4211 15.4316 26.6817 16.2137 26.6667H32.4137C33.1959 26.6817 33.9584 26.4211 34.5678 25.9305C35.1772 25.4399 35.5947 24.7507 35.7471 23.9833L38.4137 10H10.0804'
        stroke='#627B66'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_4049_195146'>
        <rect width='40' height='40' fill='white' transform='translate(0.0805664)' />
      </clipPath>
    </defs>
  </svg>
);

export const ShoppingCartIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ShoppingCartSvg} {...props} />
);
